/**
 * 환경/배포 설정. 도메인은 여기 한 곳에서만 바꾼다 (villager.ddoverse.com → 추후 교체).
 * DDoVerse nginx 컨벤션: /api/core = 인증(ddoverse-core), /api/villager = 게임 REST(villager-api),
 * /ws/villager = 실시간 시뮬(villager-sim, WebSocket).
 */
export const APP_ID = 'villager' as const;
export const APP_NAME = '마을사람 온라인' as const;
export const APP_NAME_EN = 'Villager Online' as const;

/** 초기 도메인. 나중에 교체 예정 — 코드 전체가 이 상수만 참조하도록 유지. */
export const DOMAIN = 'villager.ddoverse.com' as const;

/** 클라이언트가 호출할 경로 (nginx 프록시 기준, DDoVerse 패턴과 동일). */
export const API_BASE = {
  core: '/api/core',
  villager: '/api/villager',
} as const;

/** 실시간 시뮬 WebSocket 경로 (M4). */
export const WS_PATH = '/ws/villager' as const;
